import React from 'react';
import { Button } from "src/@/components/ui/button";
import Iconify from 'src/components/Iconify';

export default function InternetConnectionAlertPage() {
    
  
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-100">
      <div className="text-center">
        {/* <img
          src="https://via.placeholder.com/150"
          alt="Erro de Conexão"
          className="mb-6 w-40 h-40 mx-auto"
        /> */}
        <Iconify className="mb-6 w-40 h-40 mx-auto text-red-400" icon="mdi:cloud-off-outline" />
        <h1 className="text-2xl font-bold text-gray-800">
          Problema de conexão com a internet
        </h1>
        <p className="mt-2 text-gray-600">
          Parece que você está offline. Verifique sua conexão e tente novamente.
        </p>
        <Button
          className="mt-6"
          onClick={() => window.location.reload()}
        >
          Tentar Novamente
        </Button>
      </div>
    </div>
  );
}
